/* @flow */
import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { List } from 'material-ui/List';

import TutorJobOffer from './job/TutorJobOffer';
import TutorJobEmptyItem from './job/TutorJobEmptyItem';

import type { TutorPending_tutor } from './__generated__/TutorPending_tutor.graphql';

type Props = {
  tutor: TutorPending_tutor,
};

const TutorPending = ({ tutor: { jobOffers } }: Props) =>
  jobOffers && jobOffers.edges.length > 0 ? (
    <div>
      <List>
        {jobOffers.edges.map(
          edge =>
            edge &&
            edge.node && <TutorJobOffer key={edge.node.id} node={edge.node} />
        )}
      </List>
    </div>
  ) : (
    <TutorJobEmptyItem />
  );

export default createFragmentContainer(TutorPending, {
  tutor: graphql`
    fragment TutorPending_tutor on Tutor {
      jobOffers(first: 10, status: [Open]) {
        edges {
          node {
            id
            sessions {
              timeSlot {
                id
                startDate
                duration {
                  minutes
                  hours
                }
              }
            }
            totalRateStudent
            totalRateTutor
            jobRequest {
              grade {
                name
              }
              subject {
                name
              }
              student {
                firstname
                lastname
                profilePictureThumbnailUri
              }
            }
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/TutorPending.js